/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

import moduleNamesMap from '@int_acf_core/cartridge/config/moduleNamesMap';

import '../static/default/lib/js/on-screen.umd.min.js';
import '../static/default/lib/js/slick.min.js';
import '../static/default/lib/js/featherlight.min.js';
import '../static/default/lib/js/snipper.min.js';

// eslint-disable-next-line
__webpack_public_path__ = window.publicPath;

// importing custom Brand styles that will override base ones
import(/* webpackChunkName: '[request]' */ `@int_acf_core/cartridge/sass/modules_system/brands/${window.currentSiteID}/modules_system.scss`);

var inlineMarginStyles = require('./inlineMarginStyles');

// for dynamically loaded modules that are loaded after main bundle js file initialization
function loadModule(moduleType, moduleRootElRef) {
    import(/* webpackChunkName: '[request]' */'./modules/' + moduleNamesMap[moduleType]).then((module) => {
        if (module.default && module.default.initOneInstance) {
            module.default.initOneInstance(moduleRootElRef);
            if (window.modulesSystem.modulePresentOnThePage.indexOf(moduleType) === -1) {
                window.modulesSystem.modulePresentOnThePage.push(moduleId);
                window.modulesSystem.initializedModuleIds.push(moduleRootElRef.getAttribute('id'));
            }
        }
    });
}

function initCache() {
    window.modulesSystem.$cache.body = $('body');
    window.modulesSystem.$cache.html = $('html');
}

function loadModulesOnAPage(chunksMap) {
    for (var moduleType in chunksMap) {
        const isModulePresentOnPage = document.querySelector(`section.ms-module.${moduleType}`);

        if (isModulePresentOnPage) {
            const modulesList = Array.prototype.slice.call(document.querySelectorAll(`section.ms-module.${moduleType}`));
            const moduleUids = modulesList.map(moduleRootEl => moduleRootEl.getAttribute('id'));

            import(/* webpackChunkName: '[request]' */'./modules/' + chunksMap[moduleType]).then((module) => {
                if (module.default && module.default.init) {
                    module.default.init();
                    window.modulesSystem.initializedModuleIds = window.modulesSystem.initializedModuleIds.concat(moduleUids);
                }
            });
        }
    }
}

var app = {
    init: function () {
        window.modulesSystem.initializedModuleIds = [];
        window.modulesSystem.loadModule = loadModule;

        initCache();
        inlineMarginStyles.init();
        loadModulesOnAPage(moduleNamesMap);
    }
};

// export modules system js
export default app;
